<template>
    <div class="live-detail">

        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <div class="live-detail-banner-box">
            <img :src="live.cover_img" class="live-detail-banner">
            <van-count-down :time="time" class="live-detail-count-down" v-if="time > 0">
                <template #default="timeData">
                    <img class="time_img" src="/static/img/icon_live_count_down.svg" alt="">
                    <span>距离直播开始：</span>
                    <span class="times">{{ timeData.days }}</span>
                    <span class="time_unit">天</span>
                    <span class="times">{{ timeData.hours }}</span>
                    <span class="time_unit">时</span>
                    <span class="times">{{ timeData.minutes }}</span>
                    <span class="time_unit">分</span>
                    <span class="times">{{ timeData.seconds }}</span>
                    <span class="time_unit">秒</span>
                </template>
            </van-count-down>
        </div>

        <div class="live-detail-header">
            <div class="header-title">{{live.title}}</div>
            <div class="header-view">
                <div class="header-time-long">{{live.start_at_format}}</div>
                <div class="header-view-count">
                    <div class="header-view-count-text">
                        {{live.appointment_count}}人已预约
                    </div>
                    <div class="header-view-count-images">
                        <img :src="item" alt="" v-for="(item,index) in live.last_study_user_avatar" :key="index">
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="live-detail-content">
            <div class="live-detail-content-title">直播介绍</div>
            <div class="live-detail-content-detail">

                <div class="top-ad" style="margin-bottom: 30px;" v-if="content_items && content_items.length > 1">
                    <swiper ref="mySwiper2" :options="swiperOption2">
                        <swiper-slide class="series_slide" v-for="(item,index) in content_items" :key="index">
                            <div :class="'series_slide_box '+(item.is_current == 1 ? 'current' : '')"
                                 @click="goItem(item)">
                                <div class="series_slide_box-title">{{ item.title }}</div>
                                <div class="series_slide_box-time">{{ "第" + hanz[index] + "场" }}</div>
                                <div v-if="item.live_status === 0" class="series_slide_box-tags appoint">预告</div>
                                <div v-else-if="item.live_status === 1" class="series_slide_box-tags current"><img src="https://bytx.care-gobroad.com/static/bytx/activity_list_live_icon.gif" alt=""> 直播中</div>
                                <div v-else-if="item.live_status === 6" class="series_slide_box-tags end">回放</div>
                                <div v-else-if="item.live_status > 1" class="series_slide_box-tags end">已结束</div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="clear"></div>
                </div>

                <div v-html="live.content"></div>
            </div>
        </div>

        <img @click="openShareData" class="course-detail-share-button" src="/static/img/btn_share.svg" alt="">

        <div class="live-detail-footer">

            <div class="live-detail-footer-box">
                <div class="live-detail-footer-left">
                    <van-grid :column-num="1" :border="false">
                        <van-grid-item @click="favorite()" v-if="live.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏"/>
                        <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏"/>
                    </van-grid>
                </div>
                <div class="live-detail-footer-right">
                    <van-button v-if="live.isAppointment == 0" type="danger" round size="large" @click="appointment" color="#D3172E">
                        {{ time > 0 && live.live_status < 1 ? '预约直播' :'进入直播间'}}
                    </van-button>
                    <div v-else class="live-detail-subscribe_notice">
                        <div class="live-detail-subscribe_notice-left">
                            <img src="/static/img/live/pic_live_reserve.svg" alt="">
                            <span>已预约</span>
                        </div>
                        <div class="live-detail-subscribe_notice-right" @click="goDetail">
                            <img src="/static/img/live/pic_live_reserve_enter.svg" alt="">
                            <span>进入直播间</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="">
            <div v-if="showShareLoading == false">
                <div class="share-img">
                    <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="">
                </div>
                <div class="share-cancel-btn" @click="showShareDialog = false">
                    <img src="/static/img/course/icon_course_share_close.svg" alt="">
                </div>
            </div>
            <div v-else align="center">
                <van-loading size="24px">正在生成分享图片</van-loading>
            </div>
        </van-dialog>

    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import columnSkeleton from "@/skeleton/columnSkeleton"
    import verify from "../../../mixins/verify";

    export default {
        name: 'live-detail',
        mixins:[verify],
        components: {
            'column-skeleton': columnSkeleton
        },
        data() {
            return {
                live: {},
                value: "",
                active: "",
                loading: true,
                time: 0,
		        item_id:0,
                share_data: {},
                showShareDialog: false,
                showShareLoading:false,
                htmlUrl: "",
                isShow: false,
                status: "",
                swiperOption2: {
                    loop: false,
                    autoplay: false,
                    spaceBetween: 16,
                    slidesPerView: 2,
                    centerInsufficientSlides: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },
                content_items:[],
                hanz: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"],

            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'live') {
                    sessionStorage.setItem("live_id", this.id)
			        let params = {}
                    if (this.item_id != 0){
                        params.item_id = this.item_id
                    }
                    Interface.getData('get', Interface.live.detail + '/' + this.id,params).then((res) => {
                        this.live = res.data.live

                        if (res.data.live.columns && res.data.live.columns.length > 0) {
                            res.data.live.columns.forEach((val, i) => {
                                let content = val.content
                                if (val.name == '介绍') {
                                    if (content == '' && this.live.content != '') {
                                        content = this.live.content
                                    }
                                    this.live.content = content
                                }
                            })
                        }

                        if (res.data.content_items) {

                            this.content_items = res.data.content_items

                        } else {
                            this.content_items = []
                        }


                        this.time = this.live.limit_time
                        if (this.live) {
                            document.title = this.live.title
                            Interface.getShareInfo(this, this.live.title, this.live.cover_img, "点击观看直播")
                        }



                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                }else if (scene === 'view_count') {
                    let params = {
                        id: this.id,
                        type: 4,
                        increment: 2,
                    }
                    Interface.getData('post', Interface.live.view_count, params).then((res) => {

                    })
                }
            },
            favorite() {
                Interface.getData('get', Interface.live.favorite + this.id).then((res) => {
                    if (res.code == 0) {
                        this.live.isFavorite = !this.live.isFavorite
                    }
                })
            },
            appointment() {
                if(this.needGoLogin(this,this.live.hasIInWhiteList) !== 'ok'){
                    return 'notLogin'
                }

                Interface.getData('get', Interface.live.appointment + this.id).then((res) => {
                    if (res.code == 0) {
                        this.$toast.success("预约成功")
                        setTimeout(() => {
                            this.goDetail()
                        }, 1000)
                    }else{
                        this.$toast.fail(res.code+res.message)
                    }
                })
            },
            goDetail() {
                this.$router.push({name: 'live-detail-home', params: {id: this.id}})
            },
            openShareData() {
                let params = {
                    content_id: this.id,
                    type: 4,
                }
                this.showShareLoading =true
                Interface.getData('get', Interface.share, params).then((res) => {
                    this.htmlUrl = res.data.post_img_url
                    this.showShareDialog = true
                    this.showShareLoading = false
                })

            },
            goItem(item) {
                this.$router.push({name: 'live-detail', params: {id: this.id}, query: {item_id: item.id}})
                window.location.reload()
            },
        },
        created() {
            this.item_id = this.$route.query.item_id
            this.id = this.$route.params.id
            this.fetch('live')
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
    @import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/live/detail/index.vue